export default {
  meta: {
    title: '商机详情'
  }
};
